// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"c5726a8d","124":"4d2cfd2a","353":"a9009281","453":"87e45203","660":"d0bd0ed2","697":"3e7a8d07","712":"2f2095f5","819":"ac00f931","859":"22cd287e","907":"669d6401"}[chunkId] + ".chunk.js";
};